import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TableEventType } from '../models/enums/action-type.enum';
import { TableEvent } from '../models/table-event.model';

@Injectable()
export class TableGlobalEventService {
  events?: Subject<TableEvent> = new Subject();

  public sendEvent(eventType: TableEventType, payload: Record<string, unknown> = {}) {
    const events = this.events;
    events.next(TableEvent.create({eventType, payload}));
  }

  public getEventObservable(eventType: TableEventType) {
    const events = this.events;
    return events.asObservable().pipe(
      filter(event => event.eventType === eventType),
    );
  }
}
